import { render, staticRenderFns } from "./VehicleLayoutDetailsContainer.vue?vue&type=template&id=34b5ab67"
import script from "./VehicleLayoutDetailsContainer.vue?vue&type=script&lang=js"
export * from "./VehicleLayoutDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports